<template>
<div id="main">
    <div class="cardtotalDespesas">
      <div class="justify-content-center mt-2 title-card-sales">
        Total de Despesas
      </div>
      <div class="sales-value">
        <div class="stage-total" v-if="(hasRole(roles.ACC_FIN_TRAVELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.ACC_FIN_TRAVELCOORDINATOR_CENTRAL_LANEOUS_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.RW_REAL_ESTA_ADMIN)) && calcularTotalDespesaViagemUsuario.totalCoordinator > 0">
          <div class="stage-label">{{ calcularTotalDespesaViagemUsuario.totalCoordinatorDescricao || 'AG. APROVAÇÃO COORDENADOR' }}</div>
          <div class="stage-value">{{ formatMoney(calcularTotalDespesaViagemUsuario.totalCoordinator) }}</div>
        </div>
        <div class="stage-total" v-if="hasRole(roles.ACC_FIN_TRAVELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL) && calcularTotalDespesaViagemUsuario.totalTecnico > 0">
          <div class="stage-label">{{ calcularTotalDespesaViagemUsuario.totalTecnicoDescricao || 'AG. APROVAÇÃO TÉCNICO' }}</div>
          <div class="stage-value">{{ formatMoney(calcularTotalDespesaViagemUsuario.totalTecnico) }}</div>
        </div>
        <div class="stage-total" v-if="(hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.RW_REAL_ESTA_ADMIN)) && calcularTotalDespesaViagemUsuario.totalController > 0">
          <div class="stage-label">{{ calcularTotalDespesaViagemUsuario.totalControllerDescricao || 'AG. APROVAÇÃO TRANSPORTE' }}</div>
          <div class="stage-value">{{ formatMoney(calcularTotalDespesaViagemUsuario.totalController) }}</div>
        </div>
        <div class="stage-total" v-if="(hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.RW_REAL_ESTA_ADMIN)) && calcularTotalDespesaViagemUsuario.totalDirectory > 0">
          <div class="stage-label">{{ calcularTotalDespesaViagemUsuario.totalDirectoryDescricao || 'AG. APROVAÇÃO DIRETORIA' }}</div>
          <div class="stage-value">{{ formatMoney(calcularTotalDespesaViagemUsuario.totalDirectory) }}</div>
        </div>
      </div>

      <div class="employee-value">
        <div class="employee-expenses">
          <div class="employee-title">Codigo: </div>
          <div>{{ informacaFuncionario.codigoFuncionario }}</div>
        </div>

        <div class="employee-expenses">
            <div class="employee-title">Funcionário: </div>
            <div>{{ informacaFuncionario.nomeFuncionario   }} </div>
        </div>

        <div class="employee-expenses">
            <div class="employee-title">Obra: </div>
            <div>{{ informacaFuncionario.obra }} </div>
        </div>

        <div class="employee-expenses">
          <div class="employee-title">Coordenador: </div>
          <div>{{ informacaFuncionario.coordenador }}</div>
        </div>
      </div>
    </div>
  <Forms ref="frmSearch"
           title="PESQUISA DE REEMBOLSO VIAGEM"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="false"
           :ShowFooterImbo="true"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Clear="onClear"
           v-on:Search="$emit('onLoadFuncionario', dataFormSearch)"
          >
           <div>
              <div>
                <label class="label-search">Situação:</label>
                <select v-model="dataFormSearch.situacao" class="form-control">
                  <option :value="null">Selecione um status</option>
                  <option v-for="data in dataStatusDespesa" :key="data.value" :value="data.value">{{data.text}}</option>
                </select>
              </div>
              <div>
                <label class="label-search">Categoria:</label>
                 <select v-model="dataFormSearch.categoria" class="form-control">
                  <option :value="null">Selecione uma categoria </option>
                  <option v-for="data in dataEnumCategoria" :key="data.value" :value="data.value">{{data.text}}</option>
                </select>
              </div>
              <div>
                <label class="label-search">SubCategoria:</label>
                <select :disabled="getsubcategoriaData.length == 0" v-model="dataFormSearch.subcategoria"  class="form-control">
                  <option :value="null">Selecione uma sub categoria</option>
                  <option v-for="data in getsubcategoriaData" :key="data.value" :value="data.value">{{data.text}}</option>
                </select>
              </div>
           </div>
      </Forms>
</div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import Tools from '@/components/tools/Tools.js'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  name: 'Search',
  mixins: [ActionsForm],
  props: ['calcularTotalDespesaViagemUsuario', 'funcionarioidRota'],
  data () {
    return {
      dataFormSearch: localStoreHelper.viagem.prestacaoContasDetalhes() || {
        categoria: null,
        subcategoria: null,
        situacao: null
      },
      dataStatusDespesa: [],
      dataEnumCategoria: [],
      dataSubCategoriaVeiculo: [],
      dataSubCategoria: [],
      localidade: '',
      informacaFuncionario: []
    }
  },
  watch: {
    'funcionarioidRota' () {
      this.GetInfoFuncioanrio()
    }
  },
  computed: {
    getsubcategoriaData: function () {
      if (this.dataFormSearch.categoria === null || this.dataFormSearch.categoria === undefined) return []
      if (parseInt(this.dataFormSearch.categoria) === 0) return this.dataSubCategoria
      return this.dataSubCategoriaVeiculo
    },
    getsubcategoriaDataDetails: function () {
      if (this.dataExpenseDetails.categoria === null || this.dataExpenseDetails.categoria === undefined) return []
      if (parseInt(this.dataExpenseDetails.categoria) === 0) return this.dataSubCategoria
      return this.dataSubCategoriaVeiculo
    }
  },
  mounted () {
    this.GetStatusDespesa()
    this.GetCategoria()
    this.GetEnumSubCategoriaVeiculo()
    this.GetSubCategoria()
  },
  methods: {
    GetInfoFuncioanrio () {
      let id = this.funcionarioidRota
      TravelExpenseRepository.InfoFuncionario(id)
        .then((Response) => {
          this.informacaFuncionario = Response.data[0]
        })
        .catch((Error) => {
          console.error(Error)
        })
    },
    onClear () {
      localStoreHelper.viagem.prestacaoContasDetalhes(null)
      Object.keys(this.dataFormSearch).forEach((Element) => {
        this.dataFormSearch[Element] = null
      })
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    GetSubCategoria () {
      TravelExpenseRepository.GetSubCategoria()
        .then((Response) => {
          this.dataSubCategoria = Response.data
        })
        .catch((Error) => {
          console.error(Error)
        })
    },
    GetStatusDespesa () {
      TravelExpenseRepository.GetAllStatusDespesasTransporte()
        .then((Response) => {
          this.dataStatusDespesa = Response.data
        })
        .catch((Error) => {
          console.error(Error)
        })
    },
    GetCategoria () {
      TravelExpenseRepository.GetCategoria()
        .then((Response) => {
          this.dataEnumCategoria = Response.data
        })
        .catch((Error) => {
          console.error(Error)
        })
    },
    GetEnumSubCategoriaVeiculo () {
      TravelExpenseRepository.GetEnumSubCategoriaVeiculo()
        .then((Response) => {
          this.dataSubCategoriaVeiculo = Response.data
        })
        .catch((Error) => {
          console.error(Error)
        })
    }
  }

}
</script>

<style scoped>
.corpo-detalhes{
  padding: 0.2rem;
  background-color: rgb(225, 225, 225);
  border-radius: 5px;
}
.employee-expenses-cargo-obra{
  display: flex;
  justify-content: initial;
}
.cargo{
  width: 50%;
}
.coordenador {
  width: 50%;
}
.employee-expenses{
  display: flex;
  flex-direction: column;
}

.employee-title{
  font-weight: bold;
}

.employee-value {
  width: 100%;
  display: flex;
  padding: 1rem;
  font-size: 14px;
  background-color: white;
  flex-direction: column;
  font-family: 'Segoe UI';
  gap:1rem;
  border-radius: 0px 0px 8px 8px;
}

#main{
    height: 100%;
    font-family: "Segoe UI";
}
  .label-search{
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
  }
  .title-card-sales {
  font-size: 24px;
  background: #008144;
  padding: 20px;
  border-radius: 8px 8px 0px 0px;
  color: white;
  font-weight: bold;
}
.sales-value {
  padding: 0.75rem 1.25rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  font-family:'Segoe UI';
  background-color: white;
}
.stage-total {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.1rem;
  padding: 0.4rem 0;
}
.stage-total + .stage-total {
  border-top: 1px solid #eef0f1;
}
.stage-label {
  font-size: 13px;
  font-weight: 600;
  color: #5a6b62;
}
.stage-value {
  font-size: 18px;
  font-weight: bold;
  color: #025e33;
}

.cardtotalDespesas{
    margin-bottom: 2rem;
}

/* .panel-total-despesasviagem-head{
    height: 40%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center ;
    color: white;
    font-weight: bold;
    font-size: 20px;
    border-radius: 10px 10px 0px 0px;
    background: green;

  }
.panel-total-despesasviagem-body{
    height: 60%;
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 20px;
    color: black;
    align-items: center;
  }
.panel-total-despesasviagem{
  width: 100%;
    background: white;
    height: 10%;
    border-radius:10px;
    margin-bottom: 5%;
  }
  */
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/trevelexpenseemployee/components/search/search.vue